import React from 'react';

import { factory } from '../transactions/transaction/transaction-container';

import Transaction from '../transactions/transaction/transaction';

function CashTransaction(props) {
  const row = Object.assign({}, props.row, {
    quantity: null,
  });

  return (<Transaction
    {...props}
    row={row}
  />);
}

CashTransaction.propTypes = Transaction.propTypes;

export default factory({
  component: CashTransaction,
});
